import styled from 'styled-components'
import { containerExpanded } from '../../lib/styles/Container'
import { StyledLabel as StyledCheckbox } from '../../components/UI/Checkbox/styled'
import { StyledLabel, StyledTextarea } from '../../components/UI/Textarea/styled'
import { typoHeading2, typoParagraphIntro } from '../../lib/styles/Typography'

export const NewStyled = {
  Wrapper: styled.div`
    ${containerExpanded}
    margin: 3rem auto;
  `,
  Card: styled.div`
    background-color: var(--c-theme-3);
    border-radius: 1.5rem;
    color: var(--c-theme-invert);
    padding: 3rem 2rem;

    p > a {
      color: var(--c-theme-invert);
    }

    @media screen and (min-width: 768px) {
      padding: 4rem;
    }
  `,
  CardHeader: styled.header`
    margin-bottom: 2rem;
  `,
  CardTitle: styled.h2`
    ${typoHeading2}
  `,
  CardSubline: styled.p`
    ${typoParagraphIntro}
    margin-top: 0.5rem;
  `,
  CardFooter: styled.footer`
    border-top: 2px solid ${p => p.theme.colors.white[6]};
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: space-between;
    margin-top: 2rem;
    padding-top: 2rem;

    @media screen and (min-width: 768px) {
      flex-direction: row;
      gap: 1rem;
    }
  `,
  CardFooterGroup: styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
  `,
}

export const Styled = {
  Wrapper: styled.div`
    ${containerExpanded}
    color: ${({ theme }) => theme.colors.white[1]};
    margin: 2rem auto;
  `,
  Panel: styled.div`
    background-color: var(--c-theme-3);
    border-radius: 1.5rem;
    padding: 4rem;

    @media screen and (max-width: 992px) {
      padding: 3rem;
    }

    @media screen and (max-width: 480px) {
      align-items: unset;
      flex-direction: column;
      gap: 0.5rem;
      padding: 2rem;
    }
  `,
  Header: styled.div`
    margin-bottom: 2rem;
  `,
  IntroText: styled.p`
    font-size: 1.2rem;
    line-height: 1.5;
    margin-top: 0.5rem;
  `,
  // TODO: Clean up and responsive styles
  Body: styled.div`
    // display: flex;
    // flex-direction: row;
    // gap: 4rem;

    // @media screen and (max-width: 860px) {
    //   flex-direction: column;
    //   gap: 3rem;
    // }
  `,
  ProductForm: styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;

    & > * {
      flex: 1;
    }

    // @media screen and (max-width: 860px) {
    //   flex-direction: column;
    //   gap: 3rem;
    // }
  `,
  Notice: styled.p`
    font-size: 0.9rem;
    margin-top: 1rem;
  `,
  Main: styled.div`
    ${StyledCheckbox} {
      margin-bottom: 0.5rem;

      &:last-child {
        margin-bottom: 0;
      }

      a {
        color: currentColor;
      }
    }
  `,
  FieldsetWrapper: styled.div`
    display: flex;
    gap: 1rem;
    margin-bottom: 1.5rem;

    & > * {
      flex: 0.35;

      &:last-child {
        flex: 0.65;

        ${StyledLabel},
        ${StyledTextarea} {
          height: 100%;
        }
      }
    }
  `,
  Fieldset: styled.fieldset`
    border: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin: 0;
    padding: 0;
  `,
  Footer: styled.div`
    align-items: center;
    border-top: 2px solid ${({ theme }) => theme.colors.white[6]};
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
    padding-top: 2rem;
  `,
  SuccessMessage: styled.p`
    white-space: pre-line;
  `,
  ErrorMessage: styled.p`
    color: ${({ theme }) => theme.colors.red[3]};
    font-size: 0.7rem;
    font-weight: 600;
    margin-top: 0.6rem;
  `,
}
